import {Component,OnInit,TemplateRef,ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormsService } from '../services/forms.service';
import { StatusConstant, TouchesTypeId,} from 'src/app/middleware/common/status/status-constant';
import * as jwt_decode from 'jwt-decode';
import { CreatefolderforFormComponent } from 'src/app/middleware/common/createfolderforForm/createfolderforForm.component';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';
import { EditfolderforFormComponent } from 'src/app/middleware/common/editfolderforForm/editfolderforForm.component';
import { ConfirmDialogComponent,ConfirmDialogModel,} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { AssociateContactRoleFormComponent } from './associate-contact-role-form/associate-contact-role.component';
import { AssociateContactRoleFormListComponent } from './associate-contact-role-list/associate-contact-role-list.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { environment } from 'src/environments/environment';
import { FormTypes, ModuleName, ProjectTempType, RoleLevel } from '../services/form.enum';
import { MovetoFormComponent } from 'src/app/middleware/common/movetoForm/movetoForm.component';
import { AddUrlinFolderComponent } from 'src/app/middleware/common/addurlinFolder/addurlinFolder.component';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';


export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-e-dashboard',
  templateUrl: './e-dashboard.component.html',
  styleUrls: ['./e-dashboard.component.scss'],
})
export class EDashboardComponent implements OnInit {
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  FormFolderList: any = []=[];

  docDetail: boolean = false;
  showmyDrive: boolean = false;
  showFilter: boolean = false;
  menuHeader: any = [];
  ShowCreateButton: boolean = false;
  clickEventsubscription: Subscription;
  clickEventsubscription1: Subscription;
  clickEventsubscription2: Subscription;
  clickEventsubscription3: Subscription;
  filterModel:any =null;
  parentID: number=0;
  FormFolderDetail: any;
  FormFolderDetailModel: any = '';
  showFavDeletePanel: boolean = false;
  selectedRecordDeleteArray: any = [];
  searchKey:any="";
  selection = new SelectionModel(true, []);
  clickEventsubscriptionform: Subscription;
  selectedFolderIdFromLeftMenu: any;
  TypeId: number;
  deleteList: any = [];
  SelectedIdList: any = [];
  RecentlyViewFolderList: any = []=[];
  selectedForFalse: [];
  selectedForTrue: [];
  FormsubFolderFolderList: any;
  hierarchyList: any;
  SharedWithMeFormFolderList: any;
  isShowForm:any=true;
  isSharedWithMe:any=false;
  showLocalPanel: boolean = false; 
  OfficeIDList: any=[];
  myOfficeID: any;
  Module: string="";
  firstElement:any;

  showGrid:boolean = false;
  showList:boolean = true;
  
  rolesAsssign: any[] = [];
  ShowMasterTemplate:boolean=false;

  htmlData: boolean = false;
  LoggedInEmailId: string="";
  PDFReportData: boolean;
  formIcon: any;

  showGridopt(){
    this.showGrid = true;
    this.showList = false;
  }
  showListopt(){
    this.showList = true;
    this.showGrid = false;
  }
  
  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private toastr: ToastrService, private formService: FormsService, private router: Router, private statusConstant: StatusConstant,
    private dialog: MatDialog, private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef,private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.LoggedInEmailId = sessionStorage.getItem('email');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }



  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();   
    this.clickEventsubscription1.unsubscribe();
    this.clickEventsubscription2.unsubscribe();
    this.clickEventsubscription3.unsubscribe();      
  }

  ngOnInit(): void {    
    this.parentID = 0;
    this.menuHeader = [];
    this.clickEventsubscription = this._dataSharingService.getSelectedFolderFileForm().subscribe((result) => {
        if (result != '' && result != undefined) {
          this.selection.clear();
          this.selectedRecordDeleteArray = [];
          this.showFavDeletePanel = false;
          this.getform(result);
        }
      });
    this.clickEventsubscription1 = this._dataSharingService.getLoadSharedWithme().subscribe((result) => {
        if (result) {
          this.selection.clear();
          this.selectedRecordDeleteArray = [];
          this.showFavDeletePanel = false;
          this.isShowForm=false;
          this.isSharedWithMe=true;
          this.getFormFolderSharedWithMeList();
        }
      });

    // send child folders from left menu
    this.clickEventsubscription2 = this._dataSharingService.childFolderList().subscribe((result) => {    
    if(result=="sharewithme"){ 
      this.isShowForm=false;
      this.isSharedWithMe=true;
      this.ShowCreateButton=false;
      this.menuHeader=[];
      this.parentID=0;
      this.getFormFolderSharedWithMeList();
      this.FormFolderDetailModel=[];
      this.selection.clear();
      this.selectedRecordDeleteArray = [];
      this.showFavDeletePanel = false;
    }
    else if (result != '' && result != undefined) {
          this.isShowForm=true;
          this.isSharedWithMe=false;
          this.TypeId = 1;
          this.menuHeader = result.breadCrumMenu;
          this.FormFolderList = result.FormsubFolderFolderList;
          this.ShowCreateButton = true;
          this.parentID = result.formFolderID;
          this.selection.clear();
          this.selectedRecordDeleteArray = [];
          this.showFavDeletePanel = false;
          if(this.parentID!=0){
            this.GetFormFolderDetail(result.formFolderID);
          }         
        }
        else{
          this.parentID = 0;
          this.isShowForm=true;
          this.isSharedWithMe=false;
          this.menuHeader=[];
          this.FormFolderDetailModel = [];
          this.selection.clear();
          this.selectedRecordDeleteArray = [];
          this.showFavDeletePanel = false;
          this.getFormFolderList();
        }
      });
      

    this.clickEventsubscription3 = this._dataSharingService.getCurrentFormContact().subscribe((result) => {
    if(result!='' && result!=undefined) {
       this.searchName=result;
       this.showAddContact=true;
        }else{
          this.searchName="";
          this.showAddContact=false;
        }
      });

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == 'Forms');
    if(Module.length>0){
      this.Module= Module[0].orgModuleName;
    } 
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if(Module.length>0){
      this.modulenameContact= Module[0].orgModuleName;
    } 
    sessionStorage.setItem('HeaderModuleName',  this.Module);
    sessionStorage.setItem('edashboard', "false");
    this._dataSharingService.sendSelectedModuleName(this.Module);
    // this.GetRecentlyViewFolders();
    
    if(environment.production) {      
      this.showLocalPanel=false;
    }else{     
     this.showLocalPanel=true;
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){
      var role=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(role.length > 0){
       this.ShowMasterTemplate = true;
      }else{
        this.ShowMasterTemplate = false;
      }
    }
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  getFormFolderWithFormTemplatesSharedWithMe(form) {
    sessionStorage.setItem('isSharedWithMeForm','true');
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType:form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.formService.getFormFolderWithFormTemplatesSharedWithMe(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if(this.responseHolder.status == this.statusConstant.statusSuccess) {
              if(this.responseHolder.data!=null){
                this.responseHolder.data.forEach(e => {
                  if(e.webToken!=null){
                    e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
                   }
                   if(e.pdfToken!=null){   
                     e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
                   }
                  if(e.formType==3)
                  e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
                 else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                 {

                  e.signNowUrl= this.signNow(e.formTokenLink,e);
                  e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                  
                }
                });
              }
              this.SharedWithMeFormFolderList = this.responseHolder.data;
              if(this.SharedWithMeFormFolderList!=null){
                this.SharedWithMeFormFolderList.map((res) => {      
                  if (res.sharedbyFirstName != null) {
                    res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
                  }
                  if (res.sharedbyLastName != null) {
                    res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
                  }                  
                  return res;
                });              
              }
            
              this.parentID = form.id;
              sessionStorage.setItem('FolderOpenName',form.name);
              this.menuHeader.push({
                label: form.name,
                id: form.id,
                icon: 'navigate_next',
                permissionType:form.permissionType,
              });

              this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

              this.ShowCreateButton = true;
              this.GetFormFolderDetail(form.id,form.permissionType);
              this.selection.clear();
              this.selectedRecordDeleteArray = [];
              this.showFavDeletePanel = false;
            } else {
            }
          } else {
          }
        });
    } else {
      this.router.navigate(['/esignature/third'], {});
    }   
  }

  getFormFolderSharedWithMeList() { 
    var ReqModel ={
      formFolderID:0,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      OfficeID:this.myOfficeID,
      permissionType:0
    }
    this.formService.getFormFolderSharedWithMeList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          if(this.responseHolder.data!=null){
            this.responseHolder.data.forEach(e => {
              if(e.webToken!=null){
                e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
               }
               if(e.pdfToken!=null){   
                 e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
               }
              if(e.formType==3)
              e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
              else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                {
                 
                  e.signNowUrl= this.signNow(e.formTokenLink,e);
                  e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                 
                } 
            });
          }
          this.SharedWithMeFormFolderList = this.responseHolder.data;    
          if(this.SharedWithMeFormFolderList!=null){
            this.SharedWithMeFormFolderList.map((res) => {      
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }                  
              return res;
            });              
          }
        }
        else {
          this.SharedWithMeFormFolderList=[];
        }
      }
      else {
      }
    });
  
  }

  getFormFolderDetails(form){
    if(form.type == 2){
      sessionStorage.setItem('FolderOpenId',(this.parentID).toString());
      sessionStorage.setItem('ProjectName',form.name);
      sessionStorage.setItem('projectID',form.id);
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('MasterTemplateTabularForm','false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
      sessionStorage.setItem('MasterTemplateWebForm','false');
      this._dataSharingService.sendSelectedProjectName("");
      this.router.navigate(['/esignature/first']);
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }
    this.selection.clear();
    this.showFavDeletePanel = false;
    var ReqModel ={      
      formFolderID:form.id,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId),
    }
    this.loaderService.show();
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {   
          this.loaderService.hide();
          if(this.responseHolder.data!=null){
            this.responseHolder.data.forEach(e => {
              if(e.webToken!=null){
                e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
               }
               if(e.pdfToken!=null){   
                 e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
               }
              if(e.formType==3)
              e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
              else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                {
                  e.signNowUrl= this.signNow(e.formTokenLink,e);
                  e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                  
                } 
            });
          }
          this.FormsubFolderFolderList = this.responseHolder.data;       
           this.formService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConstant.statusSuccess) {                        
                this.hierarchyList = response.data.hierarchy;
                this.FormFolderList = this.FormsubFolderFolderList;
                this.menuHeader=[];                
                this.hierarchyList.forEach(e => {
                 this.menuHeader.push({ label: e.formFolderName,id:e.formFolderID,icon: 'navigate_next' });
                });
              }              
            }           
          });        
        }
        else {   
          this.loaderService.hide();     
        }
      }
      else {   
        this.loaderService.hide();   
      }
    });
    
  }

  
  breadCrumbMain() {
    this.FormFolderList = this.FormFolderList;
    this.menuHeader = [];
    this.selection.clear();
    this.selectedRecordDeleteArray = [];
    this.showFavDeletePanel = false;
  }

  breadCrumb(menu, index) {
    this.searchKey="";
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.parentID = data.id;
    this.TypeId = 1;
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoard(menu[index].id);
  }

  
  breadCrumbShareWithMe(menu, index) {
    this.searchKey="";
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getFormFolderWithFormTemplatesSharedWithMe({type:1,id:data.id,permissionType:data.permissionType});
    this.parentID = data.id;
    this.TypeId = 1;
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoard(menu[index].id);
  }

  getformnavigate(form) {
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            if(this.responseHolder.data!=null){
              this.responseHolder.data.forEach(e => {
                if(e.webToken!=null){
                  e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
                 }
                 if(e.pdfToken!=null){   
                   e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
                 }
                if(e.formType==3)
                e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
                else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                  {
                  e.signNowUrl= this.signNow(e.formTokenLink,e);
                  e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                  
                }
             
              });
            }
            this.FormFolderList = this.responseHolder.data;
            if(form.id!=0){
              this.GetFormFolderDetail(form.id);
            }else{
              this.FormFolderDetailModel=[];
            }            
            this.selection.clear();
            this.selectedRecordDeleteArray = [];
            this.showFavDeletePanel = false;
           } else {
          }
         } else {
        }
      });    
  }

  Search(filterKey):void{
    if(filterKey!=="*"){
      this.searchKey = filterKey;
    }
   
    if(filterKey!=""){
      if(filterKey=="*"){
        filterKey="";
      }
     
    var ReqModel = {
      filterModel:this.filterModel,
      searchKey:filterKey,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID,
    };
    this.loaderService.show();
    this.formService.SearchFormFolders(ReqModel).subscribe(response=>{
      if(response.data!=null){
        this.loaderService.hide();
        if(response.data!=null){
          response.data.forEach(e => {
            if(e.webToken!=null){
              e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
             }
             if(e.pdfToken!=null){   
               e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
             }
            if(e.formType==3)
              e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
            else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
              {
             e.signNowUrl= this.signNow(e.formTokenLink,e);
             e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
             
           } 
          });
        }
        this.FormFolderList = response.data;
      }
      else{
        this.FormFolderList=[];
        this.loaderService.hide();
        this.FormFolderList=[];
      }
    });
  }else{
    this.loaderService.hide();
    //this.getFormFolderList();
  }
  
  }

  SearchFilter(){
    if(this.searchKey!=""){
    var ReqModel = {
      filterModel:this.filterModel,
      searchKey:this.searchKey.trim(),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID,
    };
    this.loaderService.show();
    this.formService.SearchFormFolders(ReqModel).subscribe(response=>{
      if(response.data!=null){
        this.loaderService.hide();
        if(response.data!=null){
          response.data.forEach(e => {
            if(e.webToken!=null){
              e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
             }
             if(e.pdfToken!=null){   
               e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
             }
            if(e.formType==3)
            e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
            else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
              {
             e.signNowUrl= this.signNow(e.formTokenLink,e);
             e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
             
           }
          });
        }
        this.FormFolderList = response.data;
      }
      else{
        this.FormFolderList=[];
        this.loaderService.hide();
      }
    });
  }else{
    this.loaderService.hide();
    //this.getFormFolderList();
  }

  }
  

  showSharedContactRoleList(form: any) {
    if(form.itemCount==0){
      return;
    }
    const dialogRef = this.dialog.open(AssociateContactRoleFormListComponent, {
      id: 'addContactOrRoleDialog',
      panelClass: 'custom-modalbox',
      data: {
        moduleName: 'Forms',
        formFolderID: form.id,
        formID: form.id,
        typeId: form.type,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result!=null && result!=undefined){

      }     
    });
  }

  // GetRecentlyViewFolders() {
  //   var ReqModel = {
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //   };
  //   this.formService.GetRecentlyViewFolders(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess) {        
  //         this.RecentlyViewFolderList = this.responseHolder.data;
  //       }
  //     } else {
  //     }
  //   });
  // }

  breadCrumbMainClick() {
    this.getFormFolderList();
    this.menuHeader = [];
    this.ShowCreateButton = false;
    this.FormFolderDetail = [];
    this.selection.clear();
    this.selectedRecordDeleteArray = [];
    this.showFavDeletePanel = false;
    this.TypeId = 0;
    this.parentID = 0;
    this.FormFolderDetailModel = [];
    sessionStorage.setItem('isSharedWithMeForm','false');
  }

  breadCrumbMainSHaredWithMeClick() {
    this.getFormFolderSharedWithMeList();
    this.menuHeader = [];
    this.ShowCreateButton = false;
    this.FormFolderDetail = [];
    this.selection.clear();
    this.selectedRecordDeleteArray = [];
    this.showFavDeletePanel = false;
    this.TypeId = 0;
    this.parentID = 0;
    this.FormFolderDetailModel = [];
    sessionStorage.setItem('isSharedWithMeForm','false');
  }

  getFormFolderList() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
    };
    this.loaderService.show();
    this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.loaderService.hide();
          this.responseHolder = response;         
          if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
            if(this.responseHolder.data!=null){
              this.responseHolder.data.forEach(e => {
                if(e.webToken!=null){
                  e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
                 }
                 if(e.pdfToken!=null){   
                   e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
                 }
                if(e.formType==3)
                   e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
                else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                  {
                 e.signNowUrl= this.signNow(e.formTokenLink,e);
                 e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                 
               }
                  });
            }
            this.FormFolderList = this.responseHolder.data;
            this.FormFolderList.unshift(this.FormFolderList.splice(this.FormFolderList.findIndex(item => item.name === "My Forms"), 1)[0])
            this.firstElement = this.FormFolderList[0];
          } else {
            this.FormFolderList = [];
            this.loaderService.hide();
          }
        } else {
          this.FormFolderList = [];
          this.loaderService.hide();
        }
      });
  }

  GetFormFolderDetail(id: any,permissionType=0) {
    var ReqModel = {
      id: id,     
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formService.GetFormFolderDetail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.FormFolderDetailModel = this.responseHolder.data;
          this.FormFolderDetailModel.permissionType=permissionType;
          if (this.FormFolderDetailModel != null) {
            if (this.FormFolderDetailModel.createdByLastName != null) {
              this.FormFolderDetailModel.createdByFirstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,this.FormFolderDetailModel.createdByFirstName);
            }
            if (this.FormFolderDetailModel.createdByLastName != null) {
              this.FormFolderDetailModel.createdByLastName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,this.FormFolderDetailModel.createdByLastName);
            }

            if (this.FormFolderDetailModel.updatedByFirstName != null) {
              this.FormFolderDetailModel.updatedByFirstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,this.FormFolderDetailModel.updatedByFirstName);
            }
            if (this.FormFolderDetailModel.updatedByLastName != null) {
              this.FormFolderDetailModel.updatedByLastName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,this.FormFolderDetailModel.updatedByLastName);
            }
          }
        } else {
        }
      } else {
      }
    });
  }

  GetFormsDetail(id: any) {
    var ReqModel = {
      id: id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formService.GetFormDetail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.FormFolderDetailModel = this.responseHolder.data;
          if (this.FormFolderDetailModel != null) {
            if (this.FormFolderDetailModel.createdByLastName != null) {
              this.FormFolderDetailModel.createdByFirstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey, this.FormFolderDetailModel.createdByFirstName);
            }
            if (this.FormFolderDetailModel.createdByLastName != null) {
              this.FormFolderDetailModel.createdByLastName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey, this.FormFolderDetailModel.createdByLastName);
            }

            if (this.FormFolderDetailModel.updatedByFirstName != null) {
              this.FormFolderDetailModel.updatedByFirstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey, this.FormFolderDetailModel.updatedByFirstName);
            }
            if (this.FormFolderDetailModel.updatedByLastName != null) {
              this.FormFolderDetailModel.updatedByLastName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,this.FormFolderDetailModel.updatedByLastName);
            }
          }
        } else {
        }
      } else {
      }
    });
  }

  OpenFormOrProject(form){
    if(form.type == 1){
      this.getform(form);
    }else{
      this.openProject(form);
    }
  }

  OpenFormOrProjectSharedWithMe(form){
    if(form.type == 1){
      this.getFormFolderWithFormTemplatesSharedWithMe(form);
    }else{
      this.openProject(form);
    }
  }

  linkCopied(){
    this.toastr.success('Link copied.', '', {
    timeOut: 3000,
   });
  }  

  CreatePdfForm(Option){    
    // True-Create PDF Form
    // False-Create Master Template PDF Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplatePDFForm','true');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    }else{
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    }
    sessionStorage.removeItem('TemplateTyeValue');
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");   
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/first']);
  }

  CreateHTMLForm(Option){      
    if(Option==false){
      sessionStorage.setItem('MasterGlobalTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');     
    }else{
      sessionStorage.setItem('MasterTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');
    }
    sessionStorage.removeItem('TemplateTyeValue');
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("HtmlId");
    sessionStorage.removeItem("type");
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    this._dataSharingService.sendSelectedModuleName('Forms');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/htmlform']);
  }

  openHTMLForm(form){
    if(form.formType == 3){    
      sessionStorage.setItem('ProjectName',form.name);
      sessionStorage.setItem('HtmlId',form.id);
      sessionStorage.setItem('type',(FormTypes.HtmlForm).toString());   
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm','false');     
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');
      sessionStorage.setItem('MasterGlobalTemplateWebForm','false'); 
      sessionStorage.setItem('MasterTemplateWebForm','true');     
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
      this.router.navigate(['/esignature/htmlform']);
    }
  }

  CreateAuditForm(Option){   
    // True-Create Tabular Form
    // False-Create Master Template Tabular Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplateTabularForm','true');
    }else{
      sessionStorage.setItem('MasterTemplateTabularForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    sessionStorage.setItem('TemplateTyeValue',"2");
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/firsttabular']);
  }

  HTMLFormSign(document) {
    if(document.formType==3){
    //  Core=1, Contact=2, Company=3
      let HtmlFormSignLink= document.formTokenLink+"&placeholderID="+0+"&transactionID="+0+""
      window.open(HtmlFormSignLink, "_blank");   
      // window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+document.formTokenLink;
    }   
  }

  getform(form) {
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.loaderService.show();
      this.formService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if(this.responseHolder.status == this.statusConstant.statusSuccess) {  
              if(this.responseHolder.data!=null){
                this.responseHolder.data.forEach(e => {
                  if(e.webToken!=null){
                   e.webTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.webToken;
                  }
                  if(e.pdfToken!=null){   
                    e.pdfTokenUrl=window.location.href.split(window.location.pathname)[0]+"/request/formfolderurl?token="+e.pdfToken;          
                  }
                  if(e.formType==3 )
                   e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/HtmlFormSign?token="+e.formTokenLink;
                  else if(e.formTokenLink!=null && e.formTokenLink!=undefined && e.formTokenLink!='')
                    {
                   e.signNowUrl= this.signNow(e.formTokenLink,e);
                   e.formTokenLink= window.location.href.split(window.location.pathname)[0]+"/request/projectFromFormLink?token="+e.formTokenLink;
                   
                 
                  }
                });
              }
              this.FormFolderList = this.responseHolder.data;
              this.parentID = form.id;
              sessionStorage.setItem('FolderOpenName',form.name);
              this.menuHeader.push({
                label: form.name,
                id: form.id,
                icon: 'navigate_next',
              });

              this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

              this.ShowCreateButton = true;
              sessionStorage.setItem('isShared',  form.isShared);
              this.GetFormFolderDetail(form.id);
              this.selection.clear();
              this.selectedRecordDeleteArray = [];
              this.showFavDeletePanel = false;
            } else {
            }
          } else {
            this.loaderService.hide();
          }
        });
    } 
    if(type ==2 ){
      this.openProject(form);
    }     
  }
  signNow(token: any,form:any) {
    let params = decodeURIComponent(token);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "CoreID": 0,
      "CorePlaceholderID": 0,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": 0,
      "email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID
    };
    let jsonStringToken = JSON.stringify(objModel);
    token = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    token = encodeURIComponent(token);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (form.formType == 1)
      url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + token + "&type=1";
    else if (form.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + token + "&type=1";
   return url
  }

 selectIcon(form){
      const dialogRef = this.dialog.open(SelectFormIconComponent, {    
       
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=null && result!=undefined){
          this.formIcon = result;
          this.addDashboardQuicklink(form, result);
         // this.iconName = result.name;  
        }
      }); 
    }
  addDashboardQuicklink(form, result){   
    var ReqModel = {
     id: form.id,
     name: form.name,
     favoriteType:1, //form
     url:"",
     IsShared:form.isSharedWithMe==undefined?false:form.isSharedWithMe,
     icon:result.icon,
     color: result.color,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     databaseID: Number(this.databaseId),
     officeID:this.myOfficeID,
   };
    this.loaderService.show()
    this.formService.AddDashboardFavoriteItem(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
          this.toastr.success('Dashboard Quick Link Added successfully.', '', {
            timeOut: 3000,
          });
       } else {
        this.toastr.error('Error occurred.', '', {
          timeOut: 3000,
        });
         this.loaderService.hide();
       }
     } else {
       this.loaderService.hide();
     }
   });
   
 }

  openProject(form){   
     var ReqModel = {
      formFolderId: 0,
      formId: form.id,
      formName: form.name,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
    };
     this.loaderService.show()
     this.formService.UseFormsTemplateForProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
         if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
          if(form.type == 2 && form.formType==1){
          if(this.parentID>0)
          sessionStorage.setItem('FolderOpenId',(this.parentID).toString());
          else
          sessionStorage.setItem('FolderOpenId',(form.parentID).toString());        
          sessionStorage.setItem('projectID',response.data.projectID);
          sessionStorage.setItem('type',(ProjectTempType.Project).toString());  // 1 for Project and 2 for Template         
          this.router.navigate(['/esignature/second']);         
          sessionStorage.setItem('HeaderModuleName', 'Template');
          sessionStorage.setItem('isSharedWithMeForm','false'); 
          sessionStorage.setItem('MasterTemplatePDFForm','false');
          sessionStorage.setItem('MasterTemplateTabularForm','false');
          sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
          sessionStorage.setItem('MasterTemplateWebForm','false');
          this._dataSharingService.sendSelectedModuleName('Forms');
          this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
          }else {
           let formSigningLink= window.location.href.split(window.location.pathname)[0]+"/request/tabularsignature?token="+response.data.token;
           window.open(formSigningLink, "_blank");           
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
    
  }

  makeaCopy(form,isSWM=false) {
    if(isSWM==true){
      this.parentID=form.parentID;
    }
    // var TempName=form.name;
    // var splitTempName = TempName.split('_');
    // if(splitTempName.length > 1){
    //   var number = splitTempName[1].substr(4, 1); ;
    //   if(number==""){  
    //     TempName = TempName+"1";
    //   }else{
    //     var no = Number(number)+1;
    //     TempName = TempName.substring(0, TempName.length - 1);
    //     TempName = TempName+no;
    //   }
    // }else{
    //   TempName = TempName+"_Copy";
    // }    
    var ReqModel = {
      //formFolderId: this.parentID,
      formId: Number(form.id),
      rootFolderName:"",
      //formName:TempName,//form.name+"_Copy",
      importFromUserID: this.currentUser.UID,
      importFromOfficeID:this.myOfficeID,
      importFromOrganizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID
    };
     this.loaderService.show();
     this.formService.copyAFormFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {         
         
          if(isSWM==true)
          { 
            this.loaderService.hide();
            this.toastr.success("Template copy created successfully");
          }
          else
          {
            this.toastr.success("Template copy created successfully");
            let req = {
              id: this.parentID,
              type:1
            };
            this.loaderService.hide();
            if(isSWM){ 
              if(this.parentID==0)
              this.getFormFolderSharedWithMeList();
              else {
                this.getFormFolderWithFormTemplatesSharedWithMe(req);            
              }
            }
            else
             this.getformnavigate(req);
          }

        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getformDetails(form) {
    this.TypeId = form.type;
    this.showDocDetail()
    this.GetFormsDetail(form.id);
  }

  getformDetailsSharedWithMe(form) { 
    sessionStorage.setItem('isSharedWithMeForm','true');    
    this.TypeId = form.type;
    this.GetFormsDetail(form.id);    
  }

  openTemplate(form){
    localStorage.setItem('isDisableTabularForm','false');
    if(form.type == 2 && form.formType==1){
      if(this.parentID>0)
      sessionStorage.setItem('FolderOpenId',(this.parentID).toString());
      else
      sessionStorage.setItem('FolderOpenId',(form.parentID).toString());
      sessionStorage.setItem('ProjectName',form.name);
      sessionStorage.setItem('isSharedWithMe',form.isSharedWithMe);
      sessionStorage.setItem('projectID',form.id);
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template   
      this.router.navigate(['/esignature/third']);
      sessionStorage.setItem('HeaderModuleName', 'Template');
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
      sessionStorage.setItem('MasterTemplateWebForm','false');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }

    // For Audit Form 
    if(form.type == 2 && form.formType==2){
      if(this.parentID>0)
      sessionStorage.setItem('FolderOpenId',(this.parentID).toString());
      else
      sessionStorage.setItem('FolderOpenId',(form.parentID).toString());
      sessionStorage.setItem('ProjectName',form.name);
      sessionStorage.setItem('projectID',form.id);
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());  // 1 for Project and 2 for Template   
      sessionStorage.setItem('MasterTemplateTabularForm','false');
      this.router.navigate(['/esignature/secondtabular']);  
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName('Forms');
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }
   
  }

  

  isAllSelectedRow(event, form) {
    let ReqModel = {
      id: form.id, // FolderID  |  FormID
      itemType: form.type, //{ 1- Folder, 2- Form}
      isFavorite: form.isFavorite,
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex((itm) => itm.id === form.id);
      if (removeIndex !== -1)
        this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordDeleteArray.length > 0) {
      this.showFavDeletePanel = true;
    } else {
      this.showFavDeletePanel = false;
      this.selectedRecordDeleteArray = [];
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.FormFolderList.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.FormFolderList.forEach((row) => this.selection.select(row));
    this.selectedRecordDeleteArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        let ReqModel = {
          id: this.selection.selected[i].id, // FolderID  |  FormID
          itemType: this.selection.selected[i].type, //{ 1- Folder, 2- Form}
          isFavorite: this.selection.selected[i].isFavorite,
        };
        this.selectedRecordDeleteArray.push(ReqModel);
      }
      this.showFavDeletePanel = true;
    } else {
      this.showFavDeletePanel = false;
      this.selectedRecordDeleteArray = [];
    }
  }

  createFolders() {
    const dialogRef = this.dialog.open(CreatefolderforFormComponent, {
      data: {
        parentID: this.parentID,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        let ReqModel = {
          id: this.parentID,
        };
        this.getformnavigate(ReqModel);
        this._dataSharingService.sendRefreshListForForm(true);
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        this.showFavDeletePanel = false;
      }else{
        
      }
    });
  }

  createFoldersSharedWithMe() {
    const dialogRef = this.dialog.open(CreatefolderforFormComponent, {
      data: {
        parentID: this.parentID,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result!=null) {
        let ReqModel = {
          id: this.parentID,
          type:1
        };
        this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);
        this._dataSharingService.sendRefreshListForForm(true);
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        this.showFavDeletePanel = false;
      }
    });
  }

  RenameFolders(form) {
    const dialogRef = this.dialog.open(EditfolderforFormComponent, {
      data: {
        formFolderName: form.name,
        formFolderID: form.id, //form.formFolderID,
        parentID: form.id,
        type: form.type, //1-For Folder , 2-For Form
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result!=null) {
        let ReqModel = {
          id: this.parentID,
        };
        this.getformnavigate(ReqModel);
        this._dataSharingService.sendRefreshListForForm(true);
       // this.GetRecentlyViewFolders();
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        this.showFavDeletePanel = false;
      }
    });
  }
  
  AddSuccessDeclineUrl(form) {
    const dialogRef = this.dialog.open(AddUrlinFolderComponent, {
      data: {
        formFolderName: form.name,
        formFolderID: form.id, //form.formFolderID,
        parentID: form.id,
        type: form.type, //1-For Folder , 2-For Form
        folderData:form
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result!=null) {
        let ReqModel = {
          id: this.parentID,
        };
        this.getformnavigate(ReqModel);
        this._dataSharingService.sendRefreshListForForm(true);
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        this.showFavDeletePanel = false;
      }
    });
  }

  RenameFoldersSharedWithMe(form) {
    const dialogRef = this.dialog.open(EditfolderforFormComponent, {
      data: {
        formFolderName: form.name,
        formFolderID: form.id, //form.formFolderID,
        parentID: form.id,
        type: form.type, //1-For Folder , 2-For Form
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result!=null) {
        let ReqModel = {
          id: this.parentID,
          type:1
        };   
        if(this.parentID==0){
          this,this.getFormFolderSharedWithMeList();
        }else {
          this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);
        }
        this._dataSharingService.sendRefreshListForForm(true);
       // this.GetRecentlyViewFolders();
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        this.showFavDeletePanel = false;
      }
    });
  }

  DeleteFolders(form) {
    var message = `Are you sure you want to delete folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm); 
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: form.type, //{ 1- Folder, 2- Form}
        };
        this.selectedRecordDeleteArray=[];
        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
              };
              this._dataSharingService.sendRefreshListForForm(true);
              this.getformnavigate(ReqModel);             
              //this.GetRecentlyViewFolders();
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          }
        });
      }
    });
  }

  DeleteFoldersShareWithMe(form) {
    var message = `Are you sure you want to delete folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: form.type, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray=[];
        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
                type:1
              };
              this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
             // this.GetRecentlyViewFolders();
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          }
        });
      }
    });
  }

  DeleteTemplate(form) {
    var message = `Are you sure you want to delete template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: form.type, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray=[];
        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
              };
              this.getformnavigate(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
             // this.GetRecentlyViewFolders();
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          }
        });
      }
    });
  }


  DeleteSelectRecord() {
    var message = `Are you sure you want to delete record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        // let request = {
        //   id: form.id, // FolderID  |  FormID
        //   itemType: form.type, //{ 1- Folder, 2- Form}
        // };

        //this.selectedRecordDeleteArray=[];
        //this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
              };
              this.getformnavigate(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
             // this.GetRecentlyViewFolders();
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          }
        });
      }
    });
  }

  DeleteTemplateShareWithMe(form) {
    var message = `Are you sure you want to delete template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: form.type, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray=[];
        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
                type:1
              };
              if(this.parentID==0)
              this.getFormFolderSharedWithMeList();
              else {
                this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);              
              }
              this._dataSharingService.sendRefreshListForForm(true);
             // this.GetRecentlyViewFolders();
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          }
        });
      }
    });
  }


  DeleteSelecteOrAllFolders() {
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formService.DeleteFormItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              let ReqModel = {
                id: this.parentID,
              };
              this.getformnavigate(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
              this.selection.clear();
              this.showFavDeletePanel = false;
              this.selectedRecordDeleteArray = [];
            }
          }
        });
      }
    });
  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }
 
  AddFavorite() {
    this.deleteList = [];
    this.SelectedIdList = [];
    this.SelectedIdList = this.selectedRecordDeleteArray;

    this.selectedForFalse = this.SelectedIdList.filter((x) => x.isFavorite == false);

    if (this.selectedForFalse.length > 0) {
      this.SelectedIdList = this.SelectedIdList.filter((x) => x.isFavorite !== true);
    }

    this.selectedForTrue = this.SelectedIdList.filter((x) => x.isFavorite == true);
    if (this.selectedForTrue.length > 0) {
      this.SelectedIdList = this.SelectedIdList.filter((x) => x.isFavorite !== false);
    }

    if (this.selectedForFalse.length > 0) {
      this.deleteList = [];
      for (let i = 0; i < this.SelectedIdList.length; i++) {
        var req = {
          formFavoriteID: 0,
          id: this.SelectedIdList[i].id, //form.id,
          type: this.SelectedIdList[i].itemType, //form.type
        };
        this.deleteList.push(req);
      }

      var ReqModel = {
        items: this.deleteList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID:this.myOfficeID 
      };
      this.formService.AddFormFavorite(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            let ReqModelNew = {
              id: this.parentID,
            };
            this.getformnavigate(ReqModelNew);
          } else {
          }
        } else {
        }
      });
    }

    if (this.selectedForTrue.length > 0) {
      this.deleteList = [];
      for (let i = 0; i < this.SelectedIdList.length; i++) {
        var req = {
          formFavoriteID: 0,
          id: this.SelectedIdList[i].id, //form.id,
          type: this.SelectedIdList[i].itemType, //form.type
        };
        this.deleteList.push(req);
      }

      var ReqModel = {
        items: this.deleteList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID:this.myOfficeID   
      };
      this.formService.DeleteFormFavorite(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            let ReqModelNew = {
              id: this.parentID,
            };
            this.getformnavigate(ReqModelNew);
          } else {
          }
        } else {
        }
      });
    }

    this.showFavDeletePanel = false;
    this.selectedRecordDeleteArray = [];
  }

  DeleteFavorite(form,swm=false) {
    this.deleteList = [];
    var req = {
      formFavoriteID: 0,
      id: form.id,
      type: form.type,
    };
    this.deleteList.push(req);
    var ReqModel = {
      items: this.deleteList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formService.DeleteFormFavorite(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {         
          let ReqModel = {
            id: this.parentID,
            type:1
          };          
          if(swm) {
            if(this.parentID==0)
            this.getFormFolderSharedWithMeList();
            else {
              this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);            
            }
          }
          else
          this.getformnavigate(ReqModel);
        } else {
        }
      } else {
      }
    });

    this.showFavDeletePanel = false;
    this.selectedRecordDeleteArray = [];
  }

  AddRowFavorite(form,swm=false) {
    this.deleteList = [];
    var req = {
      formFavoriteID: 0,
      id: form.id,
      type: form.type,
    };
    this.deleteList.push(req);
    var ReqModel = {
      items: this.deleteList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID   
    };
    this.formService.AddFormFavorite(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          let ReqModel = {
            id: this.parentID,
            type:1
          };
          
          if(swm){
            if(this.parentID==0)
            this.getFormFolderSharedWithMeList();
            else {
              this.getFormFolderWithFormTemplatesSharedWithMe(ReqModel);            
            }
          }
          else
           this.getformnavigate(ReqModel);
        } else {
        }
      } else {
      }
    });

    this.showFavDeletePanel = false;
    this.selectedRecordDeleteArray = [];
  }

  addContactOrRole(form, isFolder) {   
    this.typeId = form.type;
    this.formFolderIDSendToAPI=0;
    this.formIDSendToAPI=0;
    if(this.typeId==1){
      this.mainModuleName="FormFolder";
      this.formFolderIDSendToAPI=form.id; //=IsFolder==true?folderetails.Id:0;
    }
    if(this.typeId==2){
      this.mainModuleName="Form";
      this.formIDSendToAPI=form.id;//IsFolder==true?0:folderetails.Id;
    }
    if (form.type == 1) {     
      var formFolderID = form.id;     
    }
    if (form.type == 2) {
      var formID = form.id;     
    }
    const dialogRef = this.dialog.open(AssociateContactRoleFormComponent, {
      id: 'addContactOrRoleDialog',
      panelClass: 'custom-modalbox',
      data: {
        moduleName: 'Forms',
        formFolderID: formFolderID, //folderetails.formFolderID,
        formID: formID, //folderetails.formID,
        typeId: form.type, //this.typeId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {  
      if (result != undefined && result!=null) {
        let ReqModel = {
          id: this.parentID,
        };
        this.getformnavigate(ReqModel);
        this._dataSharingService.sendRefreshListForForm(true);
       // this.GetRecentlyViewFolders();
      }    
    });
  }

  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  addShare(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  fileAccess(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  addSign(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'signatureModal',
    });
  }

  renameFile(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'renameModal',
    });
  }

  applyFilter() {
    this.showFilter = !this.showFilter;
  }

  getClose(message) {
    this.showFavDeletePanel=false;
    this.selectedRecordDeleteArray=[];
    if(!message){
      this.filterModel = null;
      this.Search("");
      this.showFilter = message;
     // this.breadCrumbMainClick();
    }
    else{
      this.filterModel = message;
      this.Search("*");
      this.showFilter=false;
    }
  }

  showDocDetail() {
    this.docDetail = !this.docDetail;
  }

  showMyDrive() {
    this.showmyDrive = !this.showmyDrive;
  }

  close() {
    this.searchName="";
    this.showAddContact=false;
    this.dialog.closeAll();
  }

  MoveTo(form) {
    //return
    var parentId=0;
    if(this.parentID>0){
      parentId =this.parentID;
    }else{
      parentId = form.id;
    }   
    const dialogRef = this.dialog.open(MovetoFormComponent, {
      data: {       
        Formid: form.id,
        parentId:parentId,
        isForm: form.type==1? false : true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=undefined && result!=null){
        if((result.newParentFolderSelected==0)||(result.newParentFolderSelected==undefined)){
          this.breadCrumbMainClick();
        }else {
          var obj={
            type:1,
            id: result.newParentFolderSelected,
          }
         this.getform(obj);
         this.menuHeader = result.menuHeaderMyForm;
        }
        //this.getFileManagerFoldersList(this.parentId,this.pageModelData);
        this._dataSharingService.sendRefreshListForForm(true);       
        this.showFavDeletePanel = false;
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
        }
      //   this._dataSharingService.getSelectedParentFolderIDForMoveFileManagerItem().subscribe(response=>{       
      // });
    });
  }

  searchName:string="";
  typeId:number=0;
  showAddContact: boolean=false;
  formFolderIDSendToAPI: number=0;
  formIDSendToAPI: number=0;
  mainModuleName: string="";
  modulenameContact:string="";

  getCloseAddNew(message){
    this.searchName="";
    this.showAddContact=false;
    this.dialog.closeAll();
  }


  openHtmlData(document) {
   // return;
    var ReqModel = {
      formID: document.id,
      formName:document.name      
    }
    this._dataSharingService.sendSelectedHTMLDataForForm(ReqModel);
    this.htmlData=true;
  }

  openPDFFormData(document) {
    // return;
     var ReqModel = {
       formID: document.id,
       formName: document.name         
     }
     this._dataSharingService.sendselectedPdfFormDataForForm(ReqModel);
     this.PDFReportData=true;
   }

  gethtmlData(message: boolean) {
    this.htmlData=true;    
  }

  getPDFData(message: boolean) {
    this.PDFReportData=true;    
  }
  
  getCloseHtmlData(closeShare: boolean) {
    this.htmlData=false;
    this.dialog.closeAll();
  }

  getClosePDFReportData(closeShare: boolean) {
    this.PDFReportData=false;
    this.dialog.closeAll();
  }

  shareOnPortal(form) {
    var message = `Are you sure you want to Share on Portal?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          forms: [form.id],
          isShared: true,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID:this.myOfficeID
        };
        this.loaderService.show();
        this.formService.formShareOnPortal(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {         
              this.loaderService.hide();
              this.toastr.success("Shared on Portal.");            
              let ReqModel = {
                id: this.parentID
              };
              this.getformnavigate(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }


  unShareOnPortal(form) {
    var message = `Are you sure you want to UnShare on Portal?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          forms: [form.id],
          isShared: false,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
          officeID:this.myOfficeID
        };
        this.loaderService.show();
        this.formService.formShareOnPortal(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {         
              this.loaderService.hide();
              this.toastr.success("UnShared on Portal.");            
              let ReqModel = {
                id: this.parentID
              };
              this.getformnavigate(ReqModel);
              this._dataSharingService.sendRefreshListForForm(true);
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }



  peoples = [
    {
      name: 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',
    },
    {
      name: 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',
    },
    {
      name: 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',
    },
    {
      name: 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',
    },
    {
      name: 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',
    },
  ];
}
